import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eVoucherList: [],
  physicalVoucher: [],
};

export const financeSlice = createSlice({
  name: "finance",
  initialState,
  reducers: {
    updateEVoucherList(state, action) {
      state.eVoucherList = action.payload.eVoucherList;
    },
    updatePhysicalList(state, action) {
      state.physicalVoucher = action.payload.physicalVoucher;
    },
    resetFinanceReset: (state) => initialState,
  },
});
export const financeActions = financeSlice.actions;
export default financeSlice.reducer;
